export default __webpack_public_path__ + "3cdbe55aca5c9a19af45766974d623bd.png";